export default __webpack_public_path__ + "static/media/location-icon-white.b3d3cb79.png";